module.exports = __webpack_public_path__ + "static/media/SWSCRC1-17.c7d81992.mp3";